export default "__VITE_ASSET__CAe_MtBf__"